export const messages = {
  requiredMessage: ["This Field is Required"],
  emailMessage: ["This Field is Required and Should be Email"],
  passwordMessage: [
    "This Field is Required and Should be more than 8 characters",
  ],
  urlMessage: ["This Field is Required and Must Be URL"],
};
